export default __webpack_public_path__ + "static/media/feature-cybersecurity-2.4908b301.png";